// firebase-config.ts
import { initializeApp } from "firebase/app";
import type { Messaging } from "firebase/messaging";

const firebaseConfig = {
 apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
export const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;

let messagingPromise: Promise<Messaging | null> | null = null;

/**
 * Firebase Messaging requires APIs that iOS in-app browsers don't provide.
 * Load it lazily and check support so push notifications can be unavailable
 * without preventing the rest of the React app from starting.
 */
export function getFirebaseMessaging(): Promise<Messaging | null> {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return Promise.resolve(null);
  }

  if (!messagingPromise) {
    messagingPromise = import("firebase/messaging")
      .then(async ({ getMessaging, isSupported }) => {
        if (!(await isSupported())) return null;
        return getMessaging(firebaseApp);
      })
      .catch((error) => {
        console.warn("Firebase Messaging is unavailable in this browser:", error);
        return null;
      });
  }

  return messagingPromise;
}
